import React from "react";
import TeamUniform from "../../components/ProductCard/TeamUniform";
import SEO from "../../components/SEO";



const TeamUniformPage = () => {
  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Custom Boxing Gloves",
    brand: "IES Gear",
    description:
      "Premium custom boxing gloves manufacturer for brands, gyms, and wholesalers.",
    manufacturer: {
      "@type": "Organization",
      name: "IES Gear",
    },
  })}
</script>
  return (
    <div className="mt-[100px] px-6 py-12 bg-white">
      <SEO
          title="Custom Team Uniform Manufacturer | IES Gear"
          description="Custom team uniforms for boxing, MMA, and sports teams with premium materials and private label branding."
          keywords="custom team uniforms manufacturer, sports team uniforms supplier, private label team uniforms"
          url="https://iesgear.com/products/team-uniform"
      />
      <h1 className="text-4xl font-bold text-center text-black mb-6">
        <span className="text-brand-color">Team</span> Uniform
      </h1>

      <p className="max-w-4xl mx-auto text-center text-gray-700 text-lg mb-10">
        Browse our collection of high-quality team uniforms tailored for comfort, durability, and style. 
        Designed with breathable fabrics and reinforced stitching, these uniforms are ideal for sports teams, 
        clubs, and organizations seeking professional and customizable athletic apparel.
      </p>

      <TeamUniform />
    </div>
  );
};

export default TeamUniformPage;
